import { render } from "./detailProjetVedette.vue?vue&type=template&id=ed6f3b98"
import script from "./detailProjetVedette.vue?vue&type=script&lang=js"
export * from "./detailProjetVedette.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__